import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import Layout from "../layout/Layout";
import Banner from "../components/home/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import About from "../components/home/About";
import Testimonials from "../components/home/Testimonials";
import { AuthContext } from "../context/AuthContext";

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard-view");
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Layout>
        <Banner />
        <IndustryLeaders />
        <About />
        <Testimonials />
      </Layout>
    </>
  );
};

export default Home;
